import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/moodsstudio.webp';
import screenshot_target from '../../../images/letterfunnel/gianlucadibella.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Gianluca Di Bella"
      firstname="Gianluca"
      companyname="Moods Studio"
      competition="OWOW Agency en Gelato"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/gianlucadibella.js